<template>
  <v-container class="pa-4" style="max-width: 500px; margin: auto">
    <v-card>
      <v-card-title class="text-h6 font-weight-bold"
        >User Information</v-card-title
      >
      <v-card-text>
        <!-- Username -->
        <div class="mb-4">
          <div><strong>Username:</strong></div>
            <div class="pl-2">{{ user.Username }}</div>
        </div>

        <!-- Fullname -->
        <div class="mb-4">
          <template v-if="!isEditing">
            <div><strong>Full Name:</strong></div>
            <div class="pl-2">{{ user.FullName }}</div>
          </template>
          <v-text-field
            v-else
            v-model="user.FullName"
            label="Full Name"
            variant="outlined"
            dense
          />
        </div>

        <!-- Email -->
        <div class="mb-2">
          <template v-if="!isEditing">
            <div><strong>Email:</strong></div>
            <div class="pl-2">{{ user.Email }}</div>
          </template>
          <v-text-field
            v-else
            v-model="user.Email"
            label="Email"
            variant="outlined"
            dense
          />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        
        <template v-if="isEditing">
          <v-btn color="primary" @click="saveUser">Save</v-btn>
          <v-btn color="grey" @click="cancelEdit">Cancel</v-btn>
        </template>
        <template v-else>
          <v-btn color="error" @click="logout">Logout</v-btn>
          <v-btn color="primary" @click="startEdit">Edit</v-btn>
          <v-btn color="primary" @click="changPassword">Change Password</v-btn>

        </template>
      </v-card-actions>
    </v-card>
  </v-container>
  
  <v-snackbar
    v-model="snackbar"
    :timeout="3000"
    :color="messType"
    top
    right>
    <span>{{ messText }}</span>
    </v-snackbar>
</template>

<script>
import VueCookies from "vue-cookies";
import axios from "../utils/axios";

export default {
  name: "UserInfo",
  data() {
    return {
      messText: null,
      messType: 'info',
      snackbar: false,
      user: {
        Username: "",
        FullName: "",
        Email: "",
      },
      originalUser: {},
      isEditing: false,
    };
  },
  async created() {
    // Lấy thông tin người dùng khi component được tạo
    const userInfo = await this.getUserInfo();
    if (userInfo) {
      this.user = userInfo;
      this.originalUser = { ...this.user };
    } else {
      this.$router.push("/login"); // Chuyển hướng đến trang đăng nhập nếu chưa đăng nhập
    }
  },
  methods: {
     async getUserInfo() {
      // Hàm này có thể được sử dụng để lấy thông tin người dùng sau khi đăng nhập thành công
      // Ví dụ: gọi API để lấy thông tin người dùng và lưu vào state hoặc localStorage
      if (!VueCookies.isKey("auth")) {
        return null; // Chưa đăng nhập
      }
      const kq = await axios.post("/User_Info")
      return kq.data[0];
    },
    startEdit() {
      this.originalUser = { ...this.user };
      this.isEditing = true;
    },
    cancelEdit() {
      this.user = { ...this.originalUser };
      this.isEditing = false;
    },
    saveUser() {
      console.log("Saving user:", this.user);
      // Gọi API nếu có
      axios.post("/User_Update_Info", this.user)
        .then(response => {
          console.log("User updated successfully:", response.data);
          this.isEditing = false;
          this.snackbar = true;
          this.messText = "User information updated successfully.";
          this.messType = 'success';
        })
        .catch(error => {
          console.error("Error updating user:", error);
          this.snackbar=true;
          this.messText = "Error updating user information.";
          this.messType = 'error';
          // Có thể hiển thị thông báo lỗi cho người dùng
        });
      this.isEditing = false;
    },
    logout() {
      VueCookies.remove("auth");
      this.$router.push("/login");
    },
    changPassword() {
      this.$router.push("/reset-password");
    },
  },
};
</script>
